import React from "react";
import { Modal } from "react-bootstrap";
import './DetailChartModal.scss';
import {IDetailChartModalState, IDetailChartModalProps} from './DetailChartModal.models'

export default class DetailChartModal extends React.PureComponent<IDetailChartModalProps, IDetailChartModalState> {

    render(): React.ReactNode {
        let { showModal , rows ,closeModal} = this.props;
        return (<>
            <Modal show={showModal} onHide={closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title>
                        نمایش تفصیلی
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="view-exam-result-details-modal">
                    <div style={{overflow:' scroll', maxHeight: '48vh'}}>
                        <table className="table table-bordered" style={{textAlign: 'right'}}>    
                            <thead>
                                <tr>
                                    <th>نام درس</th>
                                    <th>مدت زمان مطالعه</th>
                                </tr>
                                {rows !== undefined || rows!== null ? rows?.map((row,key) => {
                                    return <tr key={key}>
                                        <td>{row.title}</td>
                                        <td style={{direction:'rtl'}}>{row.value}</td>
                                    </tr>
                                }) : <></>}
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </div>
                </Modal.Body >
                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-outline-primary tk-float-left" onClick={closeModal}>بستن</button>
                </Modal.Footer>
            </Modal>
        </>);
    }
}